module.exports = __webpack_public_path__ + "assets/img/intro-normal-1.ec0cba32.jpg";